



















import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    removeName: {
      type: String,
      default: '',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: '确定',
    },
    cancelButtonText: {
      type: String,
      default: '取消',
    },
  },
  setup(props, { emit }) {
    const onClickClose = () => {
      emit('click-close');
    };

    const onClickConfirm = () => {
      emit('click-confirm');
    };

    return {
      onClickClose,
      onClickConfirm,
    };
  },
});
